module.exports = __webpack_public_path__ + "img/gucumuz_yeter@3x.91180d4f.png";